/* Lapoche bundle builder. Replaces the Upnova bundle block. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function Bundle(root) {
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-lp-config]').textContent);
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-lp-step]'));
    this.addButton = root.querySelector('[data-lp-add]');
    this.addLabel = root.querySelector('[data-lp-add-label]');
    this.error = root.querySelector('[data-lp-error]');
    this.defaultAddLabel = this.addLabel.textContent;
    this.init();
  }

  Bundle.prototype.init = function () {
    var self = this;
    this.steps.forEach(function (step) {
      var options = Array.prototype.slice.call(step.querySelectorAll('[data-lp-option]'));
      options.forEach(function (option) {
        option.addEventListener('click', function () { self.select(step, option); });
        option.addEventListener('keydown', function (e) { self.keyNav(e, options, step); });
      });
      var firstAvailable = options.filter(function (o) { return !o.disabled; })[0];
      if (firstAvailable) {
        self.select(step, firstAvailable, true);
      } else {
        step.classList.add('is-sold-out');
      }
    });
    this.addButton.addEventListener('click', function () { self.add(); });
    this.update();
  };

  Bundle.prototype.keyNav = function (e, options, step) {
    var enabled = options.filter(function (o) { return !o.disabled; });
    var i = enabled.indexOf(e.currentTarget);
    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = enabled[(i + 1) % enabled.length];
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = enabled[(i - 1 + enabled.length) % enabled.length];
    if (next) {
      e.preventDefault();
      this.select(step, next);
      next.focus();
    }
  };

  Bundle.prototype.select = function (step, option, silent) {
    Array.prototype.forEach.call(step.querySelectorAll('[data-lp-option]'), function (o) {
      var on = o === option;
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
      o.classList.toggle('is-selected', on);
    });
    step.selected = option;
    step.querySelector('[data-lp-chosen]').textContent = option.dataset.colour;
    step.querySelector('[data-lp-step-price]').textContent = formatMoney(parseInt(option.dataset.price, 10), this.config.moneyFormat);
    if (!silent) this.update();
  };

  Bundle.prototype.totals = function () {
    var full = 0;
    var complete = true;
    this.steps.forEach(function (step) {
      if (!step.selected) { complete = false; return; }
      // Saving is shown against each piece's original 'compare at' price (or its price if it has none).
      full += parseInt(step.selected.dataset.compare || step.selected.dataset.price, 10);
    });
    var price = parseInt(this.config.bundlePrice, 10) || full;
    if (!this.config.bundleAvailable) complete = false;
    return { full: full, price: price, saving: Math.max(0, full - price), complete: complete };
  };

  Bundle.prototype.update = function () {
    var t = this.totals();
    var fmt = this.config.moneyFormat;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-lp-total]'), function (el) { el.textContent = formatMoney(t.price, fmt); });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-lp-compare]'), function (el) { el.textContent = t.saving > 0 ? formatMoney(t.full, fmt) : ''; });
    var badge = this.root.querySelector('[data-lp-badge]');
    if (t.saving > 0) {
      badge.hidden = false;
      var pct = t.full > 0 ? Math.round((t.saving / t.full) * 100) : 0;
      badge.textContent = this.config.saveLabel.replace('[amount]', formatMoney(t.saving, fmt)).replace('[percent]', pct);
    } else {
      badge.hidden = true;
    }
    this.addButton.disabled = !t.complete;
    if (!t.complete) {
      this.showError(this.config.soldOutLabel);
    } else {
      this.showError('');
    }
  };

  Bundle.prototype.showError = function (message) {
    this.error.textContent = message;
    this.error.hidden = !message;
  };

  Bundle.prototype.add = function () {
    var self = this;
    var t = this.totals();
    if (!t.complete) return;

    var counts = {};
    var properties = {};
    this.steps.forEach(function (step) {
      var id = step.selected.dataset.variantId;
      counts[id] = (counts[id] || 0) + 1;
      properties[step.dataset.key] = step.selected.dataset.colour;
    });
    properties._components = Object.keys(counts).map(function (id) { return id + ':' + counts[id]; }).join(',');
    var items = [{ id: parseInt(this.config.variantId, 10), quantity: 1, properties: properties }];

    this.addButton.disabled = true;
    this.addLabel.textContent = this.config.addingLabel;
    this.showError('');

    var root = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    fetch(root + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'add failed');
          return json;
        });
      })
      .then(function () { return fetch(root + '.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
        } else {
          window.location.href = root;
        }
      })
      .catch(function (err) {
        self.showError(err && err.message && err.message !== 'add failed' ? err.message : self.config.errorLabel);
      })
      .then(function () {
        self.addLabel.textContent = self.defaultAddLabel;
        self.addButton.disabled = !self.totals().complete;
      });
  };

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lp-bundle]'), function (el) {
      if (el.lpBundle) return;
      el.lpBundle = new Bundle(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
